import { create } from "zustand";
import { api } from "../api/client";
import type { User } from "../types";

interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
  bootstrap: () => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  loading: true,
  error: null,

  bootstrap: async () => {
    if (!api.isAuthenticated) {
      set({ user: null, loading: false });
      return;
    }
    try {
      const user = await api.request<User>("/auth/me");
      set({ user, loading: false, error: null });
    } catch {
      api.logout();
      set({ user: null, loading: false });
    }
  },

  login: async (email, password) => {
    set({ error: null, loading: true });
    try {
      await api.login(email, password);
      const user = await api.request<User>("/auth/me");
      set({ user, loading: false });
    } catch (e) {
      set({
        error: e instanceof Error ? e.message : "Login failed",
        loading: false,
        user: null,
      });
      throw e;
    }
  },

  logout: () => {
    api.logout();
    set({ user: null });
  },
}));
